module.exports = __webpack_public_path__ + "static/media/bumper-selected.b0c6eb9e.svg";